export default "__VITE_ASSET__BaFHLbfU__"